/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WorkUnitsTrendBucket,
  WorkUnitsTrendBucket$inboundSchema,
} from "./workunitstrendbucket.js";

export type WorkUnitsTrendResult = {
  /**
   * One bucket per UTC day in the window, oldest first, zero-filled for days without scores.
   */
  buckets: Array<WorkUnitsTrendBucket>;
  /**
   * Whether any work-units scores exist in the window. False for organizations without work-units analysis.
   */
  scoresAvailable: boolean;
};

/** @internal */
export const WorkUnitsTrendResult$inboundSchema: z.ZodMiniType<
  WorkUnitsTrendResult,
  unknown
> = z.pipe(
  z.object({
    buckets: z.array(WorkUnitsTrendBucket$inboundSchema),
    scores_available: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "scores_available": "scoresAvailable",
    });
  }),
);

export function workUnitsTrendResultFromJSON(
  jsonString: string,
): SafeParseResult<WorkUnitsTrendResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkUnitsTrendResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkUnitsTrendResult' from JSON`,
  );
}
